const urlHelper = {
  getOperatordetails(payload: any) {
    console.log('payload', payload);
    return `/supply/operator/tds-details/${payload.opCode}`;
  },
  initiateTdsDeclaration(payload: any) {
    return `/supply/operator/generate-tds/${payload.opCode}`;
  },
};

export default urlHelper;
